export default {
    init() {
        // função para executar animação
        $('.pointer').addClass('active');

        // Select 2
        $('#sel_uf').select2();
        $('#sel_ramo').select2();
        $('#sel_cid').select2();
        $('#sel_bai').select2();

        $(document).on('keypress', '.select2-search__field', function (event) {
            $(this).val($(this).val().replace(/[^a-zA-Z].+/, ''));
            if (!((event.which >= 65 && event.which <= 90) || (event.which >= 97 && event.which <= 122))) {
                event.preventDefault();
            }
        });
        // remove campo de obrigatoriedade do select de estado - recebido por PHP 
        $('#statelists span').filter(':contains("*Este campo é obrigatório")').remove();

        var i = 0;


        function cityOnChange() {
            // função para receber e inserir campo de busca por bairros apos cidade ser escolhida
            var cid_select = $('body').find('#sel_cid');
            var cid_selected = $('body').find('#sel_cid').val();

            $(cid_select).on('change', function () {

                if (cid_selected !== $(this).val()) {
                    var c_uff = $('#sel_uf').val();
                    var c_cid = $(this).val();

                    $.ajax({
                        type: 'POST',
                        url: 'https://homologacao.quarteldesign.com/ecx/wp-content/themes/ecx/app/api/c_cid.php',
                        data: {
                            c_uff: c_uff,
                            c_cid: c_cid,
                        },
                        success: function (result) {
                            var districtHtml = $('#districtList').html()
                            if (districtHtml != result) {
                                $('#districtList').html(result);
                                $('#sel_bai').select2();

                                $(document).on('keypress', '.select2-search__field', function (event) {
                                    $(this).val($(this).val().replace(/[^a-zA-Z].+/, ''));
                                    if (!((event.which >= 65 && event.which <= 90) || (event.which >= 97 && event.which <= 122))) {
                                        event.preventDefault();
                                    }
                                });
                            }
                            var c_uf = $('#sel_uf').val();
                            var c_cid = $('#sel_cid').val();
                            var c_bai = $('body').find('#sel_bai').val();
                            $.ajax({
                                type: 'POST',
                                url: 'https://homologacao.quarteldesign.com/ecx/wp-content/themes/ecx/app/api/c_ramo.php',
                                data: {
                                    c_uf: c_uf,
                                    c_cid: c_cid,
                                    c_bai: c_bai,
                                },
                                success: function (result) {

                                    if (result != '') {
                                        var bussineTypeHtml = $('#bussinesType').html()
                                        if (bussineTypeHtml != result) {
                                            $('#bussinesType').empty();
                                            $('#bussinesType').append(result);
                                            scripts_init();
                                            i = i + 1;
                                            $('#sel_ramo').select2();

                                            $(document).on('keypress', '.select2-search__field', function (event) {
                                                $(this).val($(this).val().replace(/[^a-zA-Z].+/, ''));
                                                if (!((event.which >= 65 && event.which <= 90) || (event.which >= 97 && event.which <= 122))) {
                                                    event.preventDefault();
                                                }
                                            });
                                        }


                                    }
                                },
                                error: function (response) {
                                    alert(response);
                                },
                            })
                        },
                        error: function (response) {
                            alert(response);
                        },
                    })
                }
            });
        }
        /*  console.log($('#sel_ramo').val()); */
        // Função inicia script para funções que utilizam componentes que o ajax carrega apos o carregamento da página finalizar
        function scripts_init() {
            /*  var cid_selected = $('body').find('#sel_cid').val(); */
            cityOnChange()


            var uf_ramo = $('body').find('#sel_uf');
            /* var cid_ramo = $('body').find('#sel_cid'); */
            var bai_ramo = $('body').find('#sel_bai');

            $(uf_ramo).on('change', function () {

                var c_uf = $('#sel_uf').val();
                var c_cid = $('#sel_cid').val();
                var c_bai = $('#sel_bai').val();


                $.ajax({
                    type: 'POST',
                    url: 'https://homologacao.quarteldesign.com/ecx/wp-content/themes/ecx/app/api/c_ramo.php',
                    data: {
                        c_uf: c_uf,
                        c_cid: c_cid,
                        c_bai: c_bai,
                    },
                    success: function (result) {
                        var bussineTypeHtml = $('#bussinesType').html()
                        if (bussineTypeHtml != result) {
                            $('#bussinesType').empty();
                            if (result != '') {
                                $('#bussinesType').append(result);
                            } else {
                                $('#bussinesType').append('<select name="sel_ramo" id="sel_ramo" class="Rede_input select select2-hidden-accessible" style="font-size:16px;"data-select2-id="select2-data-sel_ramo" tabindex="-1" aria-hidden="true"><option value="" data-select2-id="select2-data-993-2i68"> Ramos de atividade </option></select>');
                            }

                            $('#sel_ramo').select2();

                            $(document).on('keypress', '.select2-search__field', function (event) {
                                $(this).val($(this).val().replace(/[^a-zA-Z].+/, ''));
                                if (!((event.which >= 65 && event.which <= 90) || (event.which >= 97 && event.which <= 122))) {
                                    event.preventDefault();
                                }
                            });

                            $('#districtList').empty();
                            $('#districtList').html('<select name="sel_bai" id="sel_bai" class="Rede_input select select2-hidden-accessible" style="font-size:16px;" data-select2-id="select2-data-sel_bai" tabindex="-1" aria-hidden="true"> <option value="" data-select2-id="select2-data-308-vnfh"> Selecione o bairro </option> </select>')
                            $('#sel_bai').select2();

                            $(document).on('keypress', '.select2-search__field', function (event) {
                                $(this).val($(this).val().replace(/[^a-zA-Z].+/, ''));
                                if (!((event.which >= 65 && event.which <= 90) || (event.which >= 97 && event.which <= 122))) {
                                    event.preventDefault();
                                }
                            });
                            scripts_init();
                        }
                    },
                    error: function (response) {
                        alert(response);
                    },
                })
            });



            $(bai_ramo).on('change', function () {
                var c_uf = $('#sel_uf').val();
                var c_cid = $('#sel_cid').val();
                var c_bai = $('#sel_bai').val();
                $.ajax({
                    type: 'POST',
                    url: 'https://homologacao.quarteldesign.com/ecx/wp-content/themes/ecx/app/api/c_ramo.php',
                    data: {
                        c_uf: c_uf,
                        c_cid: c_cid,
                        c_bai: c_bai,
                    },
                    success: function (result) {

                        $('#bussinesType').empty();
                        $('#bussinesType').append(result);
                        $('#sel_ramo').select2();

                        $(document).on('keypress', '.select2-search__field', function (event) {
                            $(this).val($(this).val().replace(/[^a-zA-Z].+/, ''));
                            if (!((event.which >= 65 && event.which <= 90) || (event.which >= 97 && event.which <= 122))) {
                                event.preventDefault();
                            }
                        });
                        scripts_init();
                    },
                    error: function (response) {
                        alert(response);
                    },
                })
            });

        }


        var uf_ramo = $('body').find('#sel_uf');
        var cid_ramo = $('body').find('#sel_cid');
        var bai_ramo = $('body').find('#sel_bai');
        $(uf_ramo).on('change', function () {
            var c_uf = $('#sel_uf').val();
            var c_cid = $('#sel_cid').val();
            var c_bai = $('#sel_bai').val();

            $.ajax({
                type: 'POST',
                url: 'https://homologacao.quarteldesign.com/ecx/wp-content/themes/ecx/app/api/c_ramo.php',
                data: {
                    c_uf: c_uf,
                    c_cid: c_cid,
                    c_bai: c_bai,
                },
                success: function (result) {
                    $('#bussinesType').empty();
                    $('#bussinesType').append(result);
                    $('#sel_ramo').select2();

                    $(document).on('keypress', '.select2-search__field', function (event) {
                        $(this).val($(this).val().replace(/[^a-zA-Z].+/, ''));
                        if (!((event.which >= 65 && event.which <= 90) || (event.which >= 97 && event.which <= 122))) {
                            event.preventDefault();
                        }
                    });
                    scripts_init();
                },
                error: function (response) {
                    alert(response);
                },
            })

        });


        $(cid_ramo).on('change', function () {
            var c_uf = $('#sel_uf').val();
            var c_cid = $('#sel_cid').val();
            var c_bai = $('body').find('#sel_bai').val();


            $.ajax({
                type: 'POST',
                url: 'https://homologacao.quarteldesign.com/ecx/wp-content/themes/ecx/app/api/c_ramo.php',
                data: {
                    c_uf: c_uf,
                    c_cid: c_cid,
                    c_bai: c_bai,
                },
                success: function (result) {
                    $('#bussinesType').empty();
                    $('#bussinesType').append(result);
                    $('#sel_ramo').select2();

                    $(document).on('keypress', '.select2-search__field', function (event) {
                        $(this).val($(this).val().replace(/[^a-zA-Z].+/, ''));
                        if (!((event.which >= 65 && event.which <= 90) || (event.which >= 97 && event.which <= 122))) {
                            event.preventDefault();
                        }
                    });
                    scripts_init();

                },
                error: function (response) {
                    alert(response);
                },
            })

        });

        $(bai_ramo).on('change', function () {
            var c_uf = $('#sel_uf').val();
            var c_cid = $('#sel_cid').val();
            var c_bai = $('#sel_bai').val();

            $.ajax({
                type: 'POST',
                url: 'https://homologacao.quarteldesign.com/ecx/wp-content/themes/ecx/app/api/c_ramo.php',
                data: {
                    c_uf: c_uf,
                    c_cid: c_cid,
                    c_bai: c_bai,
                },
                success: function (result) {
                    $('#bussinesType').empty();
                    $('#bussinesType').append(result);
                    $('#sel_ramo').select2();

                    $(document).on('keypress', '.select2-search__field', function (event) {
                        $(this).val($(this).val().replace(/[^a-zA-Z].+/, ''));
                        if (!((event.which >= 65 && event.which <= 90) || (event.which >= 97 && event.which <= 122))) {
                            event.preventDefault();
                        }
                    });
                    scripts_init();
                },
                error: function (response) {
                    alert(response);
                },
            })

        });


        // função para receber e inserir campo de busca por cidade apos estado ser escolhida
        $('#sel_uf').on('change', function () {
            var c_uf = $(this).val();
            $.ajax({
                type: 'POST',
                url: 'https://homologacao.quarteldesign.com/ecx/wp-content/themes/ecx/app/api/c_uf.php',
                data: {
                    c_uf: c_uf,
                },
                success: function (result) {
                    $('#cityList').empty();
                    $('#cityList').append(result);
                    $('#sel_cid').select2();

                    $(document).on('keypress', '.select2-search__field', function (event) {
                        $(this).val($(this).val().replace(/[^a-zA-Z].+/, ''));
                        if (!((event.which >= 65 && event.which <= 90) || (event.which >= 97 && event.which <= 122))) {
                            event.preventDefault();
                        }
                    });
                    scripts_init();
                },
            });
        });

        $('#sel_uf').on('change', function () {
            var c_uf = $(this).val();
            $.ajax({
                type: 'POST',
                url: 'https://homologacao.quarteldesign.com/ecx/wp-content/themes/ecx/app/api/c_uf.php',
                data: {
                    c_uf: c_uf,
                },
                success: function (result) {
                    $('#cityList').empty();
                    $('#cityList').append(result);
                    $('#sel_cid').select2();

                    $(document).on('keypress', '.select2-search__field', function (event) {
                        $(this).val($(this).val().replace(/[^a-zA-Z].+/, ''));
                        if (!((event.which >= 65 && event.which <= 90) || (event.which >= 97 && event.which <= 122))) {
                            event.preventDefault();
                        }
                    });
                    scripts_init();
                },
            });
        });


        $('#submit_filter').on('click', function () {
            var c_ramo = $('#sel_ramo').val();
            var c_uf = $('#sel_uf').val();
            var c_cid = $('#sel_cid').val();
            var c_bai = $('#sel_bai').val();
            var c_qrcode = $('.qr_code:checked').val();
            var business_error = $('#bussinesType .error').length;
            var state_error = $('#statelists .error').length;
            const remove = (sel) => document.querySelectorAll(sel).forEach(el => el.remove());

            // Remover erros existentes antes de realizar a validação
            remove('.error');

            if (c_uf && c_ramo) {
                $.ajax({
                    type: 'POST',
                    url: 'https://homologacao.quarteldesign.com/ecx/wp-content/themes/ecx/app/api/filter.php',
                    data: {
                        c_ramo: c_ramo,
                        c_uf: c_uf,
                        c_cid: c_cid,
                        c_bai: c_bai,
                        c_qrcode: c_qrcode,
                    },
                    beforeSend: function () {
                        var load = '<div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>'
                        $('button#submit_filter').html(load);
                    },
                    success: function (result) {
                        // Use like:
                        remove('.error');
                        $('button#submit_filter').html('Pesquisar');
                        if (result == 'SEM REGISTRO') {
                            $('.filter_response').html('<div class="notice"> <p>Não possuimos estabelecimentos desse ramo nessa localidade</p></div>');
                        } else {
                            $('.filter_response').html(result);
                            $('.item_guia_compras div div img').replaceWith('<p class="qrcode">Aceita pagamento por QR code</p>');
                        }
                        // Rolar para o elemento com o ID desejado (substitua 'seu_id' pelo ID real)
                        $('html, body').animate({
                            scrollTop: $('.notice').offset().top - 80,
                        }, 800);
                    },
                });
            } else if (c_uf == '' && state_error != 1 && c_ramo == '' && business_error != 1) {
                if ($('#c_uf').length === 0) {
                    $('#statelists').append('<p id="c_uf" class="error">* Esse campo é obrigatório</p>');
                }
                if ($('#c_ramo').length === 0) {
                    $('#bussinesType').append('<p id="c_ramo" class="error">* Esse campo é obrigatório</p>');
                }
                console.log('append erro de estado e tipo de negócio');
            } else if (c_uf == '') {
                if ($('#c_uf').length === 0) {
                    $('#statelists').append('<p id="c_uf" class="error">* Esse campo é obrigatório</p>');
                }
                console.log('append erro de Ramo');
            } else if (c_ramo == '') {
                if ($('#c_ramo').length === 0) {
                    $('#bussinesType').append('<p id="c_ramo" class="error">* Esse campo é obrigatório</p>');
                }
                console.log('append erro de estado');
            }
        });


    },
    finalize() { },
};


// WEBPACK FOOTER //
// ./scripts/routes/onde-aceita.js